<template>
  <header
    id="layout-header"
    class="group testheader relative"
    :class="transparentHeader"
    @mouseenter="changeNotTransparent"
    @mouseleave="changeToTransparent"
    v-show="!isHideHeader"
  >
    <div id="header">
      <div class="zone zone-header">
        <article class="widget-header widget-rccl-nav-widget widget">
          <input id="navIsLogin" hidden="" value="1" />
          <div class="head_top">
            <div class="logo">
              <div class="logo_img" @click="goHomePage()">
                <img
                  class="logo1"
                  :src="logoImage"
                  style="height: 100%"
                  alt="皇家加勒比国际豪华游轮"
                />
              </div>
              <!-- <div class="tran-logo">
                            <div class="tran-logo-content"></div>
                        </div> -->

            </div>
            <ul class="navi_container" style="margin-left: 181px">
              <li
                v-for="(item, i) in navItems"
                :key="item.id"
                :class="{ firstLi: i == 0 }"
              >
                <span>{{ item.title }}</span>
                <div
                  class="sub_nav animated-fast slideInDownNavMenu"
                  v-if="item.navSubItems && item.navSubItems.length > 0"
                  style="left: -32px"
                >
                  <div class="arrow" style="margin-left: 0px"></div>
                  <div class="content">
                    <div
                      class="nav_unit"
                      v-for="(subItem, j) in filterShowInPc(
                        item.navSubItems
                      )"
                      :key="j"
                    >
                      <p class="unit_txt">
                        <span class="unit_image">
                          <img :src="subItem.icon" alt="" />
                        </span>
                        {{ subItem.title }}
                      </p>
                      <a class="" @click="goLink(i+1, j+1, subItem.link)"></a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <div class="nav_contact">
              <div class="phoneCall">
                <img
                  src="https://resource.rcclchina.com.cn/partner/phone.png"
                  alt=""
                />
                <div>
                  <a
                    adhocenable="false"
                    target="_blank"
                    class="phoneCall_info"
                    id="top_callcenter_phone"
                    >400-820-7195</a
                  >
                </div>
              </div>
              <div
                class="online_service"
                id="nav_online_service"
                @click="showOnlineService"
              >
                <img
                  src="https://resource.rcclchina.com.cn/partner/online_service.png"
                  alt=""
                />
                <a class="hold_link"></a>
              </div>

              <div
                class="weibo"
                onclick="window.open('http://weibo.com/rcclchina')"
                @mouseenter="hoverWeibo"
                @mouseleave="leaveHoverWeibo"
              >
                <img class="wb-img1" :src="weiboImage" alt="" />
              </div>
              <div
                class="weixin weixinHover"
                @mouseenter="hoverWechat"
                @mouseleave="leaveHoverWechat"
              >
                <img class="wx-img1" :src="wechatImage" alt="" />
                <div class="qrCode_container"  style="width:500px;height:300px">
                  <div class="arrow"></div>
                  <div class="service_code">
                    <img
                      src="https://resource.rcclchina.com.cn/logo/PC/headerQRCode.jpg"  style="width:490px"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="nav_login" v-if="isGetUser">
              <div class="hasLogin" v-if="isLogin">
                <img
                  class="loginLogo"
                  :class="{ 'f-dn': !fullName }"
                  :src="userIcon"
                  alt=""
                />
                <a
                  class="loginId"
                  href="/Rccl.UserCenter/CustomerInfo/Info?IsHomePage=true"
                  >{{ fullName }}</a
                >
                <img
                  class="inactiveArrow"
                  src="https://resource.rcclchina.com.cn/partner/arrow_down.png"
                  alt="Alternate Text"
                />
                <div class="loginMenu">
                  <div class="arrow"></div>
                  <ul>
                    <li>
                      <div class="loginIcon">
                        <img
                          src="https://resource.rcclchina.com.cn/tui2/user_center/menu/myOrder.png"
                          alt=""
                        />
                      </div>
                      <p>我的订单</p>
                      <a class="hold_link" @click="goMyOrder()"></a>
                    </li>
                    <li>
                      <div class="loginIcon">
                        <img
                          src="https://resource.rcclchina.com.cn/tui2/user_center/menu/myCoupon.png"
                          alt=""
                        />
                      </div>
                      <p>我的优惠券</p>
                      <a class="hold_link" @click="goMyCoupon()"></a>
                    </li>
                    <li>
                      <div class="loginIcon">
                        <img
                          style=""
                          src="https://resource.rcclchina.com.cn/tui2/user_center/menu/myWishlist.png"
                          alt=""
                        />
                      </div>
                      <p>我的收藏</p>
                      <a class="hold_link" @click="goMyFavorites()"></a>
                    </li>
                    <li v-if="!isOverseaUser">
                      <a @click="goReward()" class="">
                        <div class="loginIcon">
                          <img
                            style="position: relative; left: -2px; width: 23px"
                            src="https://resource.rcclchina.com.cn/reward/side_bar_tb_home.png"
                            alt=""
                          />
                        </div>
                        <p>会员中心</p>
                      </a>
                    </li>
                    <li>
                      <div class="loginIcon">
                        <img
                          src="https://resource.rcclchina.com.cn/tui2/user_center/menu/logout.png"
                          alt=""
                        />
                      </div>
                      <p>退出</p>
                      <a @click="logout" class="hold_link"></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="needLogin" v-else>
                <a v-if="!isPartnerPage" id="top_login_link" :href="loginUrl"
                  >登录&nbsp; | &nbsp;注册</a
                >
                <a v-else id="top_login_link"
                  ><a @click="goToLogin">登录</a>&nbsp; | &nbsp;
                  <a @click="goToRegister">注册</a></a
                >
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </header>
</template>

<script>
 import api from '../api'
import Cookies from "js-cookie";
import { gioTracking, gioRecord } from '@/utilities/tools'
 import {jumpOnlineService} from "@/utilities/common";
const AGREE_PRIVACY = "AGREE_PRIVACY";
export default {
  name: "BaseHeader",
  data: () => {
    return {
      isHovered: false,
      isGetUser: false,
      routeName: "",
      logoImage: "https://resource.rcclchina.com.cn/logo/PC/logoHeaderBlue.png",
      weiboImage: "https://resource.rcclchina.com.cn/Home/new/weibo.png",
      wechatImage: "https://resource.rcclchina.com.cn/Home/new/weixin.png",
      cee:true
    };
  },
  asyncData: ({ store }) => {
    return store.dispatch("GET_NAV_ITEMS");
  },
  mounted() {
    this.getUserInfo();
    if (this.isTransparent) {
      this.changeToTransparent();
    } else {
      this.changeNotTransparent();
    }
    this.routeName = this.$router.currentRoute.name.toLowerCase();
  },
  methods: {
    filterShowInPc(navItems) {
      return navItems.filter(function (item) {
        return item.showPc;
      });
    },
    async getUserInfo() {
      const token = this.$store.state.user.userToken;
      if (token && token.length > 0) {
        this.$store.dispatch("GET_USER_INFO", token);
      } else {
        this.isGetUser = true;
      }
      //   const userInfo = this.$store.state.user.userInfo
      //   if (token && token.length > 0 && (!userInfo || !userInfo.fullName)) {
      //         const { success, data, errCode, errMsg } = await api.user.getUserInfo(token)
      //         if (success && data) {
      //             this.userInfo = data
      //             this.$store.commit("SET_USER_INFO", { userInfo: data })
      //         } else {
      //             console.error(errCode, errMsg)
      //         }
      //   }
    },
    changeToTransparent() {
      if (!this.isTransparent) return;
      this.isHovered = false;
      this.logoImage = "https://resource.rcclchina.com.cn/logo/PC/logoHeaderWhite.png";
      this.weiboImage = "https://resource.rcclchina.com.cn/partner/weibo.png";
      this.wechatImage = "https://resource.rcclchina.com.cn/partner/weixin.png";
    },
    changeNotTransparent() {
      if (!this.isTransparent) return;
      this.isHovered = true;
      this.logoImage =
        "https://resource.rcclchina.com.cn/logo/PC/logoHeaderBlue.png";
      this.weiboImage = "https://resource.rcclchina.com.cn/Home/new/weibo.png";
      this.wechatImage =
        "https://resource.rcclchina.com.cn/Home/new/weixin.png";
    },
    hoverWeibo() {
      this.weiboImage = "https://resource.rcclchina.com.cn/partner/weibo.png";
    },
    leaveHoverWeibo() {
      this.weiboImage = "https://resource.rcclchina.com.cn/Home/new/weibo.png";
    },
    hoverWechat() {
      this.wechatImage = "https://resource.rcclchina.com.cn/partner/weixin.png";
    },
    leaveHoverWechat() {
      this.wechatImage =
        "https://resource.rcclchina.com.cn/Home/new/weixin.png";
    },
    goToLogin() {
      if (this.isPartnerPage) {
        return this.$router.push({
          name: "PartnerLogin",
        });
      }
      return this.$router.push({
        name: "Login",
      });
    },
    goToRegister() {
      if (this.isPartnerPage) {
        return this.$router.push({
          name: "PartnerRegister",
        });
      }
      return this.$router.push({
        name: "Login",
      });
    },
    showOnlineService() {
      jumpOnlineService();
    },
    logout() {
      gioRecord('track', 'evt_MainMenu', {
        menu:8,
        subMenu:5,
        desUrl:''
      })
      window.sessionStorage.setItem(AGREE_PRIVACY, "null");
      this.$store.commit("REMOVE_USER_TOKEN");
      localStorage.removeItem('isAcceptPersonalRecommend');
      Cookies.remove("authed", { path: "/" });
      location.reload();
    },
    // gioTracking (menu, subMenu, desUrl) {
    //   gioTracking('track', 'evt_MainMenu', {
    //     menu,
    //     subMenu,
    //     desUrl
    //   })
    // },
    goLink(menu, subMenu, desUrl){
      gioTracking('track', 'evt_MainMenu', {
        menu,
        subMenu,
        desUrl
      })
      console.log(desUrl,'desUrl')
      if(desUrl.toLowerCase().indexOf("rclrow") > 0){
        let isFromPPP = this.$route.path == "/Rccl.Partner/Partner/Index";
        api.page.goLink({
          userName: this.$store.state.user.userToken,
          url: desUrl,
          isFromPPP : isFromPPP
        })
        .then((res) =>{
          if (res.success) {
            location.href = res.data
          } else {
            location.href = desUrl
          }
        })
      }
      else{
        location.href = desUrl
      }
    },
    goHomePage () {
      gioRecord('track', 'evt_MainMenu', {
        menu:0,
        subMenu:1,
        desUrl:'/'
      })
      window.open('/')
    },
    goWorry_free () {
      gioRecord('track', 'evt_MainMenu', {
        menu:9,
        subMenu:1,
        desUrl:'https://www.rcclchina.com.cn/Rccl.CustomPage/RcclNews/Detail/1129008.html'
      })
      window.open('https://www.rcclchina.com.cn/Rccl.CustomPage/RcclNews/Detail/1129008.html')
    },
    goMyOrder () {
      gioRecord('track', 'evt_MainMenu', {
        menu:8,
        subMenu:1,
        desUrl:'/Rccl.UserCenter/OrderRecord/List'
      })
      this.$router.push('/Rccl.UserCenter/OrderRecord/List')
    },
    goMyCoupon (){
      gioRecord('track', 'evt_MainMenu', {
        menu:8,
        subMenu:2,
        desUrl:'/Rccl.UserCenter/UserCoupon/UserCoupon'
      })
      this.$router.push('/Rccl.UserCenter/UserCoupon/UserCoupon')
    },
    goMyFavorites(){
      gioRecord('track', 'evt_MainMenu', {
        menu:8,
        subMenu:3,
        desUrl:'/Rccl.UserCenter/WishList/List'
      })
      this.$router.push('/Rccl.UserCenter/WishList/List')
    },
    goReward(){
      gioRecord('track', 'evt_MainMenu', {
        menu:8,
        subMenu:4,
        desUrl: this.rewardLink
      })
      window.location.href = this.rewardLink
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isOverseaUser () {
      if (!this.userInfo || !this.userInfo.callingCode) {
				return false;
			}
      return this.userInfo != null && this.userInfo.callingCode != "86" && this.userInfo.callingCode != '+86';
    },
    fullName() {
      if (!this.userInfo.fullName || this.userInfo.fullName.length == 0) {
        return this.userInfo.mobile;
      }
      return this.userInfo.fullName;
    },
    navItems() {
      let navItems = this.$store.state.page.navItems;
      return navItems;
    },
    isLogin() {
      const token = this.$store.state.user.userToken;
      // ppp页面，必须是ppp用户才显示登录信息
      if (this.isPartnerPage) {
        return token && token.length > 0 && this.isPartner;
      }
      return token && token.length > 0;
    },
    loginUrl() {
      // 复用当前 URL 中已有的 returnUrl，避免多次触发导致 returnUrl 重复叠加编码
      const searchParams = new URLSearchParams(location.search);
      const existingReturnUrl = searchParams.get('returnUrl');
      const returnUrl = existingReturnUrl ? encodeURIComponent(existingReturnUrl) : encodeURIComponent(location.href);
      return `/Orchard.Rccl.Users/Login/Login?returnUrl=${returnUrl}`;
    },
    isPartnerPage() {
      return (
        this.$router.currentRoute.path.toLowerCase().indexOf("rccl.partner") >=
        0
      );
    },
    isPartner() {
      return this.userInfo.isPartner;
    },
    userIcon() {
      let userIcon =
        "https://resource.rcclchina.com.cn/logo/PC/logoAvatarCircleBlueLarge.png";
      if (this.userInfo && this.userInfo.levelEN) {
        switch (this.userInfo.levelEN) {
          case "T0":
            userIcon = "";
            break;
          case "T1":
            userIcon =
              "https://resource.rcclchina.com.cn/memberCenter/pc/lv1.png";
            break;
          case "T2":
            userIcon =
              "https://resource.rcclchina.com.cn/memberCenter/pc/lv2.png";
            break;
          case "T3":
            userIcon =
              "https://resource.rcclchina.com.cn/memberCenter/pc/lv3.png";
            break;
          case "T4":
            userIcon =
              "https://resource.rcclchina.com.cn/memberCenter/pc/lv4.png";
            break;
          default:
            break;
        }
      }
      return userIcon;
    },
    isTransparent() {
      return (
        ["index", "partnerindex", "partnerregister", "partnerlogin"].indexOf(
          this.routeName.toLowerCase()
        ) >= 0
      );
    },
    isHideHeader() {
      return this.$store.state.page.isHideHeader;
    },
    transparentHeader() {
      if (this.isTransparent) {
        let classNames = { "transparent-headers": true };
        if (this.isHovered) {
          classNames["nav-hover"] = true;
        }
        return classNames;
      }
      return { "nav-hover": true };
    },
    rewardLink() {
      if (this.userInfo && this.userInfo.userIdentity == 1) {
        return `${process.env.VUE_APP_REWARD_URL}/rewardpc?token=${this.userInfo.localRewardToken}`;
      } else {
        return "/Rccl.UserCenter/CustomerInfo/SignupReward";
      }
    },
  },
  watch: {
    $route(to) {
      this.routeName = to.name.toLowerCase();
      const isTransparent =
        ["index", "partnerindex", "partnerregister", "partnerlogin"].indexOf(
          to.name.toLowerCase()
        ) >= 0;
      if (isTransparent) {
        this.changeToTransparent();
      } else {
        this.isHovered = true;
        this.changeNotTransparent();
      }
    },
    isTransparent(newValue) {
      if (newValue) {
        this.changeToTransparent();
      } else {
        this.changeNotTransparent();
      }
    },
    userInfo() {
      this.isGetUser = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" >
.head_top {
  .navi_container {
    min-width: 540px;
    height: 100%;
  }
}
.nav_login {
  .loginIcon {
    margin-right: 4px;
    img {
      display: block;
    }
  }
}
@media screen and (max-width: 1600px) {
  .head_top .qrCode_container {
    left: -230px;
  }
}
@media screen and (max-width: 1200px) {
  .head_top .qrCode_container {
    left: -300px;
  }
}
</style>
<style>
.head_top .nav_contact .phoneCall div {
  margin-left: 2px;
}
#layout-header .head_top .nav_contact .phoneCall a {
  font-size: 12px;
}
#layout-header.nav-hover .head_top .nav_contact .phoneCall,
#layout-header:hover .head_top .nav_contact .phoneCall {
  width: 120px;
}
</style>
